<template>
  <body>
    <Header headerColor="black" />
    <PartnershipProgramContent />
    <Footer />
  </body>
</template>

<script>
import Header from "@/components/SharedComponents/Header.vue";
import PartnershipProgramContent from "@/components/PartnershipProgram/PartnershipProgramContent.vue";
import Footer from "@/components/SharedComponents/Footer.vue";

export default {
  name: "sustainability",
  components: {
    Header,
    PartnershipProgramContent,
    Footer,
  },
};
</script>
